<template>
	<div style="overflow-y: hidden">
        <!-- =================== 导航 =================== -->
		<header class="black-bg mh-header mh-fixed-nav nav-scroll mh-xs-mobile-nav" id="mh-header">
			<navigation></navigation>
		</header>

        <!-- =================== 设置 =================== -->
        <setting></setting>

        <!-- =================== 公众号 =================== -->
        <section class="container" style="margin-top: 100px;">
            <v-card class="pa-3">
                <v-row>
                    <v-col cols="12" md="2">
                            <v-img src="/static/images/profile/wechat-offiaccount.jpg"></v-img><br/>
                    </v-col>
                    <v-col cols="12" md="10">
                        <v-list three-line>
                            <template>
                                <div class="ml-5">{{ $t('blog.welcome') }}</div>
                                <v-divider></v-divider>
                                <v-list-item>
                                    <v-list-item-avatar size="68">
                                        <v-img src="/static/images/blog/offiaccount-avatar.jpg"></v-img>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <h3>一个正经的程序员</h3>
                                        </v-list-item-title>
                                        <v-list-item-subtitle>记录和分享技术干货，包括但不限于 Java，Next.js，Vue.js，SpringBoot，JavaScript，MySQL，Redis，Windows，Linux，Intellij IDEA 等主流技术，生活, 情感话题等人生领悟！</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                          </v-list>
                    </v-col>
                </v-row>
            </v-card>
        </section>

        <!-- =================== 合集 =================== -->
        <section class="container">
            <v-card class="pa-3">
                <v-chip class="ma-2" :color="selectedAlbumId == null ? 'primary-bg' : ''" @click="getArticles()">{{ $t('blog.all') }}</v-chip>
                <v-chip class="ma-2" v-for="album in albums" :key="album.id" :color="selectedAlbumId == album.id ? 'primary-bg' : ''" @click="getArticlesByAlbumId(album.id)">{{ album.title }}</v-chip>
            </v-card>
        </section>

        <!-- =================== 文章 =================== -->
        <section class="container mt-16">
            <v-row v-if="loading" class="justify-center" >
                <v-progress-circular width="5" size="50" indeterminate></v-progress-circular>
            </v-row>
            <v-row v-else>
                <v-col cols="12" v-if="selectedAlbumId == null">
                    <h5>
                        <span>{{ articles.length }} {{ $t('blog.articles') }}</span>
                    </h5>
                </v-col>
                <v-col cols="12" v-else>
                    <h5>
                        <a :href="'https://mp.weixin.qq.com/mp/appmsgalbum?action=getalbum&album_id=' + selectedAlbumId" target="_blank">
                            {{ articles.length }} {{ $t('blog.articles') }}
                            <span class="mdi mdi-arrow-top-right-bold-box-outline"></span>
                        </a>
                    </h5>
                </v-col>
                <v-col v-for="(article, i) in articles" :key="article.key" cols="12">
                    <v-card>
                        <div class="d-flex flex-no-wrap">
                            <v-avatar class="ma-3" size="150" tile>
                                <v-img :src="article.cover_img"></v-img>
                            </v-avatar>
                            <div>
                                <v-card-title>
                                    <h4>
                                        <a target="_blank" :href="article.url">{{ locale == 'zh-CN' ? article.title : $pinyin.getPinyin(article.title, ' ', true) }}</a>
                                    </h4>
                                </v-card-title>
                                <v-card-subtitle>
                                    <span>{{ $t('blog.postOn') + ': ' }}</span>
                                    <span class="mt-2">{{ $tools.formatDateTime(Number(article.create_time) * 1000) }}</span>
                                </v-card-subtitle>
                    
                                <v-card-actions>
                                    <a target="_blank" :href="article.url">
                                        <v-btn class="ml-2 mt-5" outlined rounded >
                                            {{ $t('blog.readMore') }}
                                        </v-btn>
                                    </a>
                                </v-card-actions>
                            </div>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
        </section>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'
import Navigation from '@/components/Navigation.vue'
import Setting from '@/components/Setting.vue'
import BlogAPI from '@/api/blog.js'
export default {
    data(){
        return {
            loading: false,
            // 选中的合集主键
            selectedAlbumId: null,
            // 所有合集集合
            albums: [],
            // 所有文章集合
         	articles: [],
        }
    },
    components: { Navigation, Setting },
    created(){

    },
    mounted(){
        this.getAlbums();
        this.getArticles();
    },
    computed: {
        ...mapGetters(['locale'])
    },
    watch:{

    },
    methods: {
        async getAlbums(){
            this.albums = [];
			let res = await BlogAPI.getAlbums();
			let data = res.data;
			if(data.code == 200) {
				this.albums = data.data;
			}
		},
        async getArticles(){
            this.loading = true;
            this.selectedAlbumId = null;
            this.articles = [];
			let res = await BlogAPI.getArticles();
			let data = res.data;
			if(data.code == 200) {
				this.articles = data.data;
			}
            this.loading = false;
		},
        async getArticlesByAlbumId(albumId){
            this.loading = true;
            this.selectedAlbumId = albumId;
            this.articles = [];
			let res = await BlogAPI.getArticlesByAlbumId(albumId);
			let data = res.data;
			if(data.code == 200) {
				this.articles = data.data;
			}
            this.loading = false;
		},
    }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/blog/Blogs.vue